@use "~/styles/mixins" as *;

.root {
  @include df-center;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  gap: 1rem;
}
